var App = App || {};

App.Spinner = (function ($) {
	'use strict';

	var spinnerStateKey = "__appSpinnerState";

	function getSpinnerMode(element) {
		if (element.hasClass("ldl-bare")) {
			return "bare";
		}

		if (element.hasClass("ldl-partial")) {
			return "partial";
		}

		return "full";
	}

	function getSpinnerId(element) {
		var spinnerId = element.attr("data-spinner-id");

		if (spinnerId && spinnerId.trim().length) {
			return spinnerId;
		}

		spinnerId = generateUniqueId();
		element.attr("data-spinner-id", spinnerId);

		return spinnerId;
	}

	function getSpinnerState(element) {
		var state = element.data(spinnerStateKey);

		if (!state) {
			state = {
				spinnerId: "",
				selector: "",
				mode: "",
				loader: null,
				isRunning: false,
				generation: 0,
				onTimeoutId: null,
				buttonTextTimeoutId: null,
				loadingTextTimeoutId: null
			};

			element.data(spinnerStateKey, state);
		}

		return state;
	}

	function clearSpinnerTimeouts(state) {
		if (state.onTimeoutId) {
			clearTimeout(state.onTimeoutId);
			state.onTimeoutId = null;
		}

		if (state.buttonTextTimeoutId) {
			clearTimeout(state.buttonTextTimeoutId);
			state.buttonTextTimeoutId = null;
		}

		if (state.loadingTextTimeoutId) {
			clearTimeout(state.loadingTextTimeoutId);
			state.loadingTextTimeoutId = null;
		}
	}

	function ensureSpinnerDom(element, state, optionalText) {
		if ($(state.selector).length) {
			return;
		}

		if (state.mode == "bare") {
			element.append(generateBareLdld(state.spinnerId));
			return;
		}

		generateFullLdld(state.spinnerId, state.mode, optionalText).insertAfter(element);
	}

	function ensureSpinnerLoader(state) {
		if (!state.loader) {
			state.loader = new ldloader({ root: state.selector });
		}
	}

	function getButtonTextElement(element) {
		return element.children(".text").first();
	}

	function startSpinner(element, optionalText = "") {
		if (!element || !element.length) {
			return;
		}

		var state = getSpinnerState(element);
		state.mode = getSpinnerMode(element);
		state.spinnerId = getSpinnerId(element);
		state.selector = "#" + state.spinnerId;

		ensureSpinnerDom(element, state, optionalText);
		ensureSpinnerLoader(state);

		state.generation++;
		clearSpinnerTimeouts(state);

		var currentGeneration = state.generation;

		if (state.isRunning) {
			if (state.mode == "bare") {
				var runningButtonTextElem = getButtonTextElement(element);

				if (runningButtonTextElem.length && optionalText.length) {
					runningButtonTextElem.text(optionalText);
				}
			}
			else if (optionalText.length) {
				$(state.selector).find(".loading-text").text(optionalText);
			}

			return;
		}

		state.isRunning = true;

		state.onTimeoutId = setTimeout(function () {
			if (state.generation !== currentGeneration || !state.isRunning) {
				return;
			}

			state.loader.on();
			state.onTimeoutId = null;
		}, 10);

		if (state.mode == "bare") {
			element.addClass("disabled");

			var buttonTextElem = getButtonTextElement(element);

			if (buttonTextElem.length) {
				if (typeof buttonTextElem.attr("data-original-text") === "undefined") {
					buttonTextElem.attr("data-original-text", buttonTextElem.text());
				}

				buttonTextElem
					.attr("aria-live", "polite")
					.attr("aria-atomic", "true");

				var newText = optionalText.length ? optionalText : "Loading";

				state.buttonTextTimeoutId = setTimeout(function () {
					if (state.generation !== currentGeneration || !state.isRunning) {
						return;
					}

					buttonTextElem.text(newText);
					state.buttonTextTimeoutId = null;
				}, 10);
			}
		}
		else if (optionalText.length) {
			state.loadingTextTimeoutId = setTimeout(function () {
				if (state.generation !== currentGeneration || !state.isRunning) {
					return;
				}

				$(state.selector).find(".loading-text").text(optionalText);
				state.loadingTextTimeoutId = null;
			}, 200);
		}
	}

	function stopSpinner(element) {
		if (!element || !element.length) {
			return;
		}

		var state = getSpinnerState(element);
		var spinnerId = state.spinnerId || element.attr("data-spinner-id");

		if (!spinnerId || !spinnerId.trim().length) {
			return;
		}

		state.spinnerId = spinnerId;
		state.selector = "#" + spinnerId;
		state.mode = state.mode || getSpinnerMode(element);

		ensureSpinnerLoader(state);

		state.generation++;
		state.isRunning = false;
		clearSpinnerTimeouts(state);

		state.loader.off();
		element.removeClass("disabled");

		var buttonTextElem = getButtonTextElement(element);

		if (buttonTextElem.length) {
			var originalText = buttonTextElem.attr("data-original-text");

			if (typeof originalText !== "undefined") {
				buttonTextElem.text(originalText);
			}
		}

		$(state.selector).find(".loading-text").text("");
	}

	function generateUniqueId() {
		var newId = "ldld-" + Math.floor(Math.random() * 26) + Date.now();

		if ($("#" + newId).length) {
			return generateUniqueId();
		}

		return newId;
	}

	function generateFullLdld(uniqueId, adnlClass = "", optionalText = "") {
		var fullLdldString = '<div id="' + uniqueId + '" class="ldld full ' + adnlClass + '"><div class="lds-background"><div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';

		if (optionalText.length) {
			fullLdldString += '<div class="rich-text loading-text" aria-live="polite" aria-atomic="true"></div>';
		}

		fullLdldString += '</div>';

		return $(fullLdldString);
	}

	function generateBareLdld(uniqueId) {
		return $('<div id="' + uniqueId + '" class="ldld bare ml-2 align-middle"><div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>');
	}

	return {
		startSpinner: startSpinner,
		stopSpinner: stopSpinner
	};

})(jQuery);